export const getCPSParticipantsSwitchIDSystemSetting = () =>
axios.get(
  `/api/systemsetting/module/D83CE071-50DA-40E3-B8BB-689884D8AF78/public`
);